/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActivityManifestEntry } from './ActivityManifestEntry';
import {
    ActivityManifestEntryFromJSON,
    ActivityManifestEntryFromJSONTyped,
    ActivityManifestEntryToJSON,
    ActivityManifestEntryToJSONTyped,
} from './ActivityManifestEntry';

/**
 * Returned to the frontend and never interpreted by the backend. This is what makes the
 * frontend data-driven: a new venue is a manifest edit, not a release.
 * 
 * Solo visits (`session_id: null`) have no session to carry one, so the backend holds a
 * **default manifest** in settings and serves it as `MyVisit.manifest`. Serving a default is
 * not interpreting it — the opacity rule is unchanged — and keeping it server-side preserves
 * the property above for solo play, which a frontend constant would not.
 * 
 * @export
 * @interface ActivityManifest
 */
export interface ActivityManifest {
    /**
     * 
     */
    activities: Array<ActivityManifestEntry>;
}

/**
 * Check if a given object implements the ActivityManifest interface.
 */
export function instanceOfActivityManifest(value: object): value is ActivityManifest {
    if (!('activities' in value) || value['activities'] === undefined) return false;
    return true;
}

export function ActivityManifestFromJSON(json: any): ActivityManifest {
    return ActivityManifestFromJSONTyped(json, false);
}

export function ActivityManifestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityManifest {
    if (json == null) {
        return json;
    }
    return {
        
        'activities': ((json['activities'] as Array<any>).map(ActivityManifestEntryFromJSON)),
    };
}

export function ActivityManifestToJSON(json: any): ActivityManifest {
    return ActivityManifestToJSONTyped(json, false);
}

export function ActivityManifestToJSONTyped(value?: ActivityManifest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activities': ((value['activities'] as Array<any>).map(ActivityManifestEntryToJSON)),
    };
}

